import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { debounce } from '../../../library/Core/SmartFunctions';
import RecruiterDirectoryService from './RecruiterDirectoryService';

import SessionContext from '../../../library/Core/SessionContext';
import { SessionStateType } from '../../../library/Core/SmartTypes';
import { handleClearAllFilterClick } from './RecruiterSearchControl';
import { useParams } from 'react-router-dom';

const imgPotentialRecruiters = `${process.env.REACT_APP_IMAGE_BASEPATH}/potential-recruiters.svg`;
const imgMultinationalCorporation = `${process.env.REACT_APP_IMAGE_BASEPATH}/group-91019.svg`;
const imgStartups = `${process.env.REACT_APP_IMAGE_BASEPATH}/shuttle.svg`;
const imgRecruitedFromCampus = `${process.env.REACT_APP_IMAGE_BASEPATH}/selection.svg`;
const imgMaximumPotentialBatch = `${process.env.REACT_APP_IMAGE_BASEPATH}/target.svg`;

const RecruiterSummaryCardControl = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { pageName,type } = useParams();
    console.log("type",type)
    
    const { sessionState } = useContext(SessionContext);
    const { userTypeCode, instituteGroupId: schoolGroupId, primaryInstitute,instituteId } = sessionState as SessionStateType;
    const summaryCardsData = state.data.summary;
    const directoryLevel = state.data.searchLevel;
    const UserinstituteId = primaryInstitute ?? instituteId ;
    const instituteType = JSON.parse(state?.domain?.get('INSTITUTE_DOMAIN')?.find((element) => element.code == UserinstituteId)?.flexCol as string).institute_type;
    
    const [searchName, setSearchName] = useState('');

     const cardsConfig = [
        {
            id: 'potentialRecruiter',
            label: 'Potential Recruiters',
            image: imgPotentialRecruiters,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip :'Recruiters who may engage in hiring but have not yet confirmed participation.'
        },
        {
            id: 'mncs',
            label: 'Multinational Corporation',
            image: imgMultinationalCorporation,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip : 'Recruiters operating across multiple countries or regions.'
        },
        {
            id: 'startups',
            label: 'Start-ups',
            image: imgStartups,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip : 'Emerging or early-stage companies actively hiring talent.'
        },
        {
            id: 'recruitedFromCampus',
            label: 'Recruited from Campus',
            image: imgRecruitedFromCampus,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip :'Recruiters who have previously hired candidates from this campus.'
        },
        {
            id: 'maxPotentialBatch',
            label: 'Maximum Potential',
            image: imgMaximumPotentialBatch,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip :'Academic batch with the highest likelihood of recruiter engagement and hiring.'
        }

    ];

    const summaryCardsControl = cardsConfig.filter((card) => (card.applicableForUserType.includes(userTypeCode) && card.applicableForInstituteType.includes(instituteType)));

    const handleSummaryCardClick = (id: string) => {
        if (summaryCardsData[id] <= 0) {
            dispatch({ type: 'REFRESH_DATA', payload: { data: { ...state.data, students: [] } } });
            return;
        }
        const cardFiltersToBeRemoved = ['isPotentialRecruiter','isMNC', 'isStartUp', 'isRecruitedFromCampus', 'passOutYear','recruiterStatus'];
        const filters = Object.fromEntries(
            Object.entries(state?.data?.filters).filter(
              ([key]) => !cardFiltersToBeRemoved.includes(key)
            )
        );
          
        RecruiterDirectoryService.performSearchWithUserSelectedCriteria({
            ...filters,
            context: { searchBy: '', level: directoryLevel, selectedCard: id },
            ...RecruiterDirectoryService.getCriteriaForSelectedCard(id, state)
        }, state, dispatch);
    };

    const debouncedHandleNameSearch = debounce((value: string) => {
        console.log("selectedCard",state.data.selectedCard)
        const searchCriteria: any = { ...state?.data?.filters,name: value };
      RecruiterDirectoryService.performSearchWithUserSelectedCriteria(searchCriteria, state, dispatch);

    }, 200); // Adjust the debounce time as needed (in milliseconds)

    const handleNameSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchName(event.target.value);
        debouncedHandleNameSearch(event.target.value);
    };

    const handleNameSearchClear = () => {
        setSearchName('');
        debouncedHandleNameSearch('');
    };

    const getCardBorder = (currentCard: string) => (currentCard === state.data.selectedCard ? 'active' : '');

    const [isShowSearch, setShowSearch] = useState(false);
    const [showResetButton, setshowResetButton] = useState(false);

    //Show/hide reset button based on filter changes
    useEffect(() => {
        if(JSON.stringify(state.data.filters) != JSON.stringify(RecruiterDirectoryService.getDefaultSearchCriteria(''))){
            setshowResetButton(true);
        }
        else{
            setshowResetButton(false);
        }
    }, [state.data.filters]);

    const handleSearchToggle = () => {
        setShowSearch(!isShowSearch);
    };

    return (
        <>
            {type !== 'broadcast' ? (
                <>
                    <section
                        className="bg-red pt-3 pt-sm-5 pb-3 container-fluid"
                        id="alumni_directory"
                        data-aos="fade-down"
                    >
                        <div className="max-1140 mx-auto">
                              <div className="row alumni-directory">
                                <div className="col-lg-12 alumni-directory-header">
                                    <div className="alumni-directory-header_search">
                                        <h2
                                            data-aos="fade-left"
                                            data-aos-delay="300"
                                            className="font-22 font-600 text-white mb-3 mb-sm-0 me-3 aos-init aos-animate">
                                            Recruiter <span className="d-block d-sm-inline-block">Directory</span>
                                        </h2>
                                        {/* {userTypeCode != 'STUDENT' && ( */}
                                        <div className={`alumni-directorySearch-wrap ${isShowSearch ? 'show' : ''}`}>
                                            <form className="alumni-directorySearch" onSubmit={(event) => event.preventDefault()}>
                                                <button type="button" className="btn icon-search height-40"></button>
                                                <input
                                                    className=" form-control height-40"
                                                    type="search"
                                                    placeholder="Search by Alumni"
                                                    id="SearchStudent"
                                                    aria-label="Search"
                                                    value={searchName}
                                                    onChange={handleNameSearch}
                                                />
                                                <a className="btn-cross" id="SearchStudentBtnCross" onClick={handleNameSearchClear}></a>
                                            </form>
                                            {/* <a className="btn-alumniSearchToggle icon-search d-flex d-sm-none"></a> */}
                                            <a
                                                className="btn-alumniSearchToggle cursor-pointer icon-search d-flex d-sm-none"
                                                onClick={handleSearchToggle}>
                                            </a>
                                            <div id="Studentsuggestionbox" style={{ display: 'none' }}></div>
                                        </div>
                                        {showResetButton && <div className={`alumni-directorySearch-wrap ${isShowSearch ? 'show' : ''}`}>
                                            <button type="button" className="ms-2 btn btn-white-border height-40 mt-0" onClick={(e) => handleClearAllFilterClick(e, state, dispatch)}><span>Reset</span></button>
                                        </div>}
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row">
                                    <div className="aldir_scroll active">
                                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                                            {summaryCardsControl.map((control: any) => (
                                                <div key={control.id} className="col mb-4 aldir_box">
                                                    <div
                                                        className={`bg-white rounded alumni-directory-block h-100 aos-init aos-animate ${getCardBorder(
                                                            control.id
                                                        )}`}
                                                        data-aos="fade-up"
                                                        role="button"
                                                        onClick={() => handleSummaryCardClick(control.id)}
                                                        data-aos-delay="600">
                                                        <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                                            {summaryCardsData[control.id] ?? 0} {control.id === 'maxPotentialBatch' ? (<span className="font-16 font-500 text-dark-blue">(Batch)</span>) : ''}
                                                            <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title={control.tooltip}></i>
                                                            {/* <a className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <div className="font-16 font-500 flex-1">{control.label}</div>
                                                            <div className="alumni-directory-img me-3 mb-3">
                                                                <img src={control.image} className="img-fluid" alt="Total Joined Alumni" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </>
            ) : (
                <>
                    <section className="alumni_directory_details container-fluid bg-white">
                        <div className="max-1140 overflow-hidden mx-auto">
                            <div className="d-flex justify-content-between align-items-center py-4">
                                <h3
                                    data-aos="fade-left"
                                    data-aos-delay="600"
                                    className="font-35 font-600 mb-0 block-title position-relative"
                                >
                                    Create New Broadcast
                                </h3>

                                <div className="custom_step">
                                    <span>Step 2</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );

};

export default RecruiterSummaryCardControl;
